import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTDeleteAPIStageInstanceResult,
	RESTGetAPIStageInstanceResult,
	RESTPatchAPIStageInstanceJSONBody,
	RESTPatchAPIStageInstanceResult,
	RESTPostAPIStageInstanceJSONBody,
	RESTPostAPIStageInstanceResult
} from "discord-api-types/v10";





class StageInstanceMethods {








	public constructor(public requestHandler: RH) {}


















	public async createStageInstance(data: RESTPostAPIStageInstanceJSONBody & { reason?: string; }): Promise<RESTPostAPIStageInstanceResult> {
		return this.requestHandler.request(Endpoints.STAGE_INSTANCES, {}, "post", "json", data);
	}











	public async getStageInstance(channelId: string): Promise<RESTGetAPIStageInstanceResult> {
		return this.requestHandler.request(Endpoints.STAGE_INSTANCE_CHANNEL(channelId), {}, "get", "json");
	}


















	public async editStageInstance(channelId: string, data: RESTPatchAPIStageInstanceJSONBody & { reason?: string; }): Promise<RESTPatchAPIStageInstanceResult> {
		return this.requestHandler.request(Endpoints.STAGE_INSTANCE_CHANNEL(channelId), {}, "patch", "json", data);
	}


















	public async deleteStageInstance(channelId: string, reason?: string): Promise<RESTDeleteAPIStageInstanceResult> {
		return this.requestHandler.request(Endpoints.STAGE_INSTANCE_CHANNEL(channelId), {}, "delete", "json", { reason }) as RESTDeleteAPIStageInstanceResult;
	}
}

export = StageInstanceMethods;
